import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const LINKEDIN_URL = "https://www.linkedin.com/in/jamescarlrhule/";
const CV_URL =`${process.env.PUBLIC_URL}/cv/james-carl-rhule-cv.docx`;

const LINKS = [
  { label: "Experience", to: "/initiatives" },
  { label: "Gallery", to: "/gallery" },
  { label: "About", to: { pathname: "/", hash: "#about" } },
  { label: "Contact", to: { pathname: "/", hash: "#contact" } },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <>
      <header className="fixed inset-x-0 top-0 z-40 border-b border-line bg-white/92 backdrop-blur">
        <div className="mx-auto flex max-w-content items-center justify-between px-6 py-5 md:px-12">
          <Link to="/" className="font-serif text-[1.05rem] font-medium tracking-tight text-teal-900">
            James Carl-Rhule
          </Link>

          <nav className="hidden items-center gap-8 md:flex">
            {LINKS.map((l) => (
              typeof l.to === "string" ? (
                <NavLink
                  key={l.label}
                  to={l.to}
                  className={({ isActive }) =>
                    `text-[0.7rem] uppercase tracking-widest2 transition-colors ${
                      isActive ? "text-teal-900" : "text-ink-soft hover:text-teal-900"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ) : (
                <Link
                  key={l.label}
                  to={l.to}
                  className="text-[0.7rem] uppercase tracking-widest2 text-ink-soft transition-colors hover:text-teal-900"
                >
                  {l.label}
                </Link>
              )
            ))}
            <span className="h-3 w-px bg-line-strong" aria-hidden="true" />
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noreferrer"
              className="text-[0.7rem] uppercase tracking-widest2 text-ink-soft transition-colors hover:text-teal-900"
            >
              LinkedIn
            </a>
            <a
              href={CV_URL}
              target="_blank"
              rel="noreferrer"
              className="text-[0.7rem] uppercase tracking-widest2 text-ink-soft transition-colors hover:text-teal-900"
            >
              CV
            </a>
          </nav>

          <button
            className="flex flex-col gap-[5px] p-1 md:hidden"
            aria-label={open ? "Close menu" : "Open menu"}
            onClick={() => setOpen((v) => !v)}
          >
            <span className={`block h-px w-5 bg-teal-900 transition-transform ${open ? "translate-y-[6px] rotate-45" : ""}`} />
            <span className={`block h-px w-5 bg-teal-900 transition-opacity ${open ? "opacity-0" : ""}`} />
            <span className={`block h-px w-5 bg-teal-900 transition-transform ${open ? "-translate-y-[6px] -rotate-45" : ""}`} />
          </button>
        </div>
      </header>

      {open && (
        <div className="fixed inset-0 z-30 flex flex-col justify-center gap-8 bg-white px-10 md:hidden">
          <Link to="/" className="font-serif text-3xl text-teal-900">Home</Link>
          {LINKS.map((l) => (
            <Link key={l.label} to={l.to} className="font-serif text-3xl text-teal-900">{l.label}</Link>
          ))}
          <a href={LINKEDIN_URL} target="_blank" rel="noreferrer" className="mt-4 text-xs uppercase tracking-widest2 text-ink-soft">
            LinkedIn
          </a>
          <a href={CV_URL} target="_blank" rel="noreferrer" className="text-xs uppercase tracking-widest2 text-ink-soft">
            Download CV
          </a>
        </div>
      )}
    </>
  );
}
